import React from "react";
import {
  StyledAuth,
  StyledAuthCard,
  StyledAuthCardHeader,
  StyledAuthMainContent,
  StyledAuthWelContent,
  StyledAuthWellAction,
  StyledAuthWrap,
  StyledMainAuthScrollbar,
} from "./index.styled";
import AppLogo from "@lib/components/AppComponents/AppLayout/components/AppLogo";
import AppAnimateGroup from "@lib/components/AppComponents/AppAnimateGroup";
import { FormattedMessage } from "react-intl";
import { Typography } from "antd";
import { APP_NAME, APP_VERSION } from "@lib/constants/AppConst";
import { AppLayoutProps } from "@lib/components/AppComponents/AppLayout/Layouts";

const NonAuthLayout: React.FC<AppLayoutProps> = ({ children }) => {
  return (
    <StyledAuth>
      <StyledMainAuthScrollbar>
        <AppAnimateGroup
          type="scale"
          animatestyle={{ flex: 1 }}
          delay={0}
          style={{ height: "100vh" }}
          interval={10}
          duration={200}
        >
          <StyledAuthWrap key={"wrap"}>
            <StyledAuthCard>
              <StyledAuthMainContent>
                <StyledAuthCardHeader>
                  <AppLogo />
                </StyledAuthCardHeader>

                {children}
              </StyledAuthMainContent>
              <StyledAuthWellAction>
                <StyledAuthWelContent>
                  <h2>
                    <FormattedMessage
                      id={"common.welcomeToSystem"}
                      values={{ brandName: APP_NAME }}
                    />
                  </h2>
                </StyledAuthWelContent>
              </StyledAuthWellAction>
            </StyledAuthCard>

            <Typography.Text
              copyable={{ text: APP_VERSION }}
              style={{ marginTop: 20 }}
            >
              v{APP_VERSION}
            </Typography.Text>
          </StyledAuthWrap>
        </AppAnimateGroup>
      </StyledMainAuthScrollbar>
    </StyledAuth>
  );
};

export default NonAuthLayout;
